import AvatarPlaceholder from "../../assets/auth/register/avatar-placeholder.png";
import YoutubeEmbed from "./youtube";
import Langs from "../../utils/data/langs.json";
import { useSelector } from "react-redux";

const tabTitleBase =
    "w-full cursor-pointer border-b-[3px] border-[#eee] pb-2.5 text-center text-sm text-nt-grey transition-colors";
const tabTitleActive = "border-nt-red text-nt-blue";

const formationRow =
    "mb-0 flex flex-wrap max-md:mb-5 max-md:flex-col md:mb-0 [&:not(:last-child)]:max-md:mb-5";
const formationDateCol = "w-full shrink-0 text-nt-blue max-md:w-full md:w-1/5";
const formationBodyCol =
    "w-full min-w-0 text-justify md:w-4/5 [&_h3]:text-base [&_h3]:font-semibold [&_h3]:text-nt-blue [&_h4]:text-sm [&_h4]:font-normal [&_h4]:text-nt-grey [&_p]:text-sm [&_p]:text-nt-grey";

const SingleTutor = ({ filePreview = false, profile, activeTab, setActiveTab }) => {
    const accessToken = useSelector((state) => state.auth.accessToken);

    const secureDocumentHref = (file) => {
        if (!file?.path || !accessToken) {
            return null;
        }
        const name = file.name || String(file.path).replace(/^\/document\//, "").replace(/^\//, "");
        const base = process.env.REACT_APP_BACKEND_DOMAIN || "";
        return `${base}admin/profile/document/${encodeURIComponent(name)}?access_token=${encodeURIComponent(accessToken)}`;
    };

    const getLangName = (key) => {
        return Langs.find((item) => {
            return item.value == key;
        })?.name;
    };

    const LangTag = ({ lang }) => {
        return lang.name?.trim() !== "" && lang.level?.trim() !== "" ? (
            <div className="flex items-end gap-[5px] rounded-[5px] bg-[#eee]">
                <span className="px-[5px] py-0 text-sm font-medium text-nt-blue">{getLangName(lang.lang)}</span>
                <span className="rounded-br rounded-tr bg-nt-grey px-1.5 py-0.5 text-xs font-light text-white">
                    {lang.level}
                </span>
            </div>
        ) : (
            ""
        );
    };

    return (
        <div className="flex flex-col rounded-[10px] bg-white p-5">
            <div className="flex items-center justify-between max-xl:flex-col max-xl:gap-2.5">
                <div className="flex w-full justify-start gap-2.5">
                    <div className="shrink-0 [&_img]:rounded-full">
                        <img
                            className="h-[100px] w-[100px] object-cover"
                            src={
                                profile.avatar?.length > 0 && profile.avatar[0] instanceof Blob
                                    ? URL.createObjectURL(profile.avatar[0])
                                    : profile.avatar?.length > 0 && !Array.isArray(profile.avatar)
                                      ? process.env.REACT_APP_BACKEND_URL + profile.avatar
                                      : AvatarPlaceholder
                            }
                            width={100}
                            alt=""
                        />
                    </div>
                    <div className="flex flex-col items-start justify-start gap-2.5 [&_h3]:text-nt-blue [&_h3_img]:ml-2.5 [&_h3_img]:inline">
                        <h3 className="capitalize">
                            {profile.firstName + " " + profile.lastName}
                            {profile.country && profile.country?.length && (
                                <img src={`https://flagsapi.com/${profile.country}/shiny/24.png`} alt="" />
                            )}
                        </h3>
                        {profile.teach && profile.teach.length ? (
                            <div className="flex items-baseline gap-2.5 max-sm:flex-col">
                                <div className="text-sm text-nt-grey">Teaches:</div>
                                <div className="flex flex-row flex-wrap gap-x-5 gap-y-2.5">
                                    {profile.teach.map((lang, i) => {
                                        return <LangTag lang={lang} key={i} />;
                                    })}
                                </div>
                            </div>
                        ) : null}
                        {profile.speak && profile.speak.length ? (
                            <div className="flex items-baseline gap-2.5 max-sm:flex-col">
                                <div className="text-sm text-nt-grey">Speaks:</div>
                                <div className="flex flex-row flex-wrap gap-x-5 gap-y-2.5">
                                    {profile.speak.map((lang, i) => {
                                        return <LangTag lang={lang} key={i} />;
                                    })}
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>
                <div className="[&_iframe]:h-[168px] [&_iframe]:w-[300px]">
                    {profile.youtube?.length ? <YoutubeEmbed url={profile.youtube} /> : ""}
                </div>
            </div>
            <div className="p-5">
                <ul className="flex w-full flex-col text-nt-blue md:flex-row">
                    <li
                        onClick={() => setActiveTab(0)}
                        className={`${tabTitleBase} ${activeTab === 0 ? tabTitleActive : ""}`}
                    >
                        About Me
                    </li>
                    <li
                        onClick={() => setActiveTab(1)}
                        className={`${tabTitleBase} ${activeTab === 1 ? tabTitleActive : ""}`}
                    >
                        Education
                    </li>
                    <li
                        onClick={() => setActiveTab(2)}
                        className={`${tabTitleBase} ${activeTab === 2 ? tabTitleActive : ""}`}
                    >
                        Work Experience
                    </li>
                    <li
                        onClick={() => setActiveTab(3)}
                        className={`${tabTitleBase} ${activeTab === 3 ? tabTitleActive : ""}`}
                    >
                        Certificates
                    </li>
                </ul>

                <div className="pt-5 text-justify">
                    {activeTab === 0 && (
                        <div
                            className="[&_li]:font-light [&_ol]:ml-5 [&_ol]:list-decimal [&_ol_li]:font-light [&_p]:font-normal [&_ul]:ml-5 [&_ul]:list-disc [&_ul_li]:font-light"
                            dangerouslySetInnerHTML={{ __html: profile.description }}
                        />
                    )}
                    {activeTab === 1 && (
                        <div>
                            {!profile.noEducation &&
                                profile.education?.length &&
                                profile.education
                                    .sort((a, b) => b.to - (a.toPresent ? 3000 : a.to))
                                    .map((formation, i) => {
                                        const period =
                                            formation.from + " - " + (formation.toPresent ? " Present" : formation.to);
                                        const fileHref = secureDocumentHref(formation.file);
                                        return (
                                            <div className={formationRow} key={i}>
                                                <div className={formationDateCol}>
                                                    {formation.from != "" && period}
                                                </div>
                                                <div className={formationBodyCol}>
                                                    <h3>{formation.label}</h3>
                                                    <h4>{formation.school}</h4>
                                                    <p>{formation.description}</p>
                                                </div>
                                                {filePreview && (
                                                    <div className="w-[100px] self-start rounded-md bg-nt-blue text-center">
                                                        {fileHref && (
                                                            <a
                                                                href={fileHref}
                                                                className="text-white no-underline"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Show File
                                                            </a>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                            {profile.noEducation && <h4>No education level</h4>}
                        </div>
                    )}
                    {activeTab === 2 && (
                        <div>
                            {!profile.noExperience && profile.experience?.length ? (
                                profile.experience
                                    .sort((a, b) => b.to - (a.toPresent ? 3000 : a.to))
                                    .map((formation, i) => {
                                        const period =
                                            formation.from + " - " + (formation.toPresent ? " Present" : formation.to);
                                        const fileHref = secureDocumentHref(formation.file);
                                        return (
                                            <div className={formationRow} key={i}>
                                                <div className={formationDateCol}>
                                                    {formation.from != "" && period}
                                                </div>
                                                <div className={formationBodyCol}>
                                                    <h3>{formation.label}</h3>
                                                    <h4>{formation.company}</h4>
                                                    <p>{formation.description}</p>
                                                </div>
                                                <div className="w-[100px] self-start rounded-md bg-nt-blue text-center">
                                                    {fileHref && (
                                                        <a
                                                            href={fileHref}
                                                            className="text-white no-underline"
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            Show File
                                                        </a>
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    })
                            ) : (
                                ""
                            )}
                            {profile.noExperience && <h4 className="text-nt-blue">No work experience</h4>}
                        </div>
                    )}
                    {activeTab === 3 && (
                        <div>
                            {!profile.noCertificate && profile.certificates?.length ? (
                                profile.certificates
                                    .sort((a, b) => b.to - (a.toPresent ? 3000 : a.to))
                                    .map((formation, i) => {
                                        const fileHref = secureDocumentHref(formation.file);
                                        return (
                                            <div className={formationRow} key={i}>
                                                <div className={formationDateCol}>{formation.year}</div>
                                                <div className={formationBodyCol}>
                                                    <h3>{formation.label}</h3>
                                                    <p>{formation.description}</p>
                                                </div>
                                                <div className="w-[100px] self-start rounded-md bg-nt-blue text-center">
                                                    {fileHref && (
                                                        <a
                                                            href={fileHref}
                                                            className="text-white no-underline"
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            Show File
                                                        </a>
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    })
                            ) : (
                                ""
                            )}
                            {profile.noCertificate && <h4>No certificates</h4>}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export { SingleTutor };
